import { ApiPage, emptyApiPage } from "../models/api-page.model";

import { apiService } from "./api.service";

export class NotificationService {
  private static BASE_PATH = "/api/v1/notifications/";

  static async addsingleTemplate(request: any): Promise<any | null> {
    const response = await apiService.post(`${this.BASE_PATH}manual`, request);
    return response;
  }

  static async getNotificationStatus(audience: string): Promise<ApiPage<Request>> {
    const response = await apiService.get(`${this.BASE_PATH}active?audience=${audience}`);
    if (!response.success) return emptyApiPage<Request>();

    return response.data as ApiPage<Request>;
  }
  static async getStripeStatus(): Promise<ApiPage<Request>> {
    const response = await apiService.get(`${this.BASE_PATH}stripe`);
    if (!response.success) return emptyApiPage<Request>();
    return response.data as ApiPage<Request>;
  }

  static async getStripeActiveStatus(): Promise<ApiPage<Request>> {
    const response = await apiService.get(`${this.BASE_PATH}stripe/active`);
    if (!response.success) return emptyApiPage<Request>();

    return response.data as ApiPage<Request>;
  }

  static async getNotificationData(): Promise<ApiPage<Request>> {
    const response = await apiService.get(`${this.BASE_PATH}all`);
    if (!response.success) return emptyApiPage<Request>();
    return response.data as ApiPage<Request>;
  }
  static async updateNotificationData(request: any): Promise<any | null> {
    const response = await apiService.put(`${this.BASE_PATH}${request?.notificationId}`, request);
    return response;
  }
}
